/**
 * מזהה אקראי (UUID v4). crypto.randomUUID חסר בדפדפנים ישנים (Chrome/WebView לפני 92, Safari לפני 15.4) — במכשירים כאלה
 * (טאבלטים ישנים, טלפוני אנדרואיד ישנים) האפליקציה הייתה נשברת בשליחת הפתק הראשון. לכן נופלים ל-getRandomValues.
 */
export function newId(): string {
  const c: Crypto | undefined = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  const bytes = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(bytes);
  else for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // גרסה 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // וריאנט RFC 4122
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return [hex.slice(0, 4), hex.slice(4, 6), hex.slice(6, 8), hex.slice(8, 10), hex.slice(10)].map((p) => p.join('')).join('-');
}
